module.exports = __webpack_public_path__ + "img/downloadBtn.e2ec8f6f.png";